import { jsxs as a, Fragment as d, jsx as e } from "react/jsx-runtime";
import { FileListItemProgress as l } from "./FileListItemProgress.mjs";
import f from "./FileListItemStatusText.mjs";
const F = ({
  file: r,
  progressPercentage: i,
  status: t,
  "data-testid": s,
  error: m,
  id: o
}) => /* @__PURE__ */ a(d, { children: [
  /* @__PURE__ */ e(
    l,
    {
      id: o,
      "data-testid": s,
      fileName: `${r.name}`,
      progressPercentage: i,
      status: t
    }
  ),
  /* @__PURE__ */ e(f, { error: m, status: t })
] });
export {
  F as default
};
